module.exports = __webpack_public_path__ + "img/buy_en.0807b85d.png";